import React, { useRef, useEffect, useState } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';

interface FloatingAddButtonProps {
  text: string;
  onClick: () => void;
}

const FloatingAddButton: React.FC<FloatingAddButtonProps> = ({ text, onClick }) => {
  const textRef = useRef<HTMLParagraphElement>(null);
  const [textWidth, setTextWidth] = useState(160);

  useEffect(() => {
    if (textRef.current) {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      if (context) {
        context.font = '18px system-ui';
        const width = context.measureText(`${text} +`).width;
        setTextWidth(Math.max(width + 40, 160));
      }
    }
  }, [text]);

  return (
    <Flex
      position="fixed"
      bottom="24px"
      right="24px"
      zIndex={10}
      bg="#5b182b"
      color="white"
      borderRadius="full"
      boxShadow="lg"
      cursor="pointer"
      onClick={onClick}
      transition="all 0.3s ease"
      _hover={{
        w: `${textWidth}px`,
        borderRadius: '30px',
        bg: '#691f30',
        boxShadow: 'xl',
        '& .texto': {
          opacity: 1
        },
        '& .icono': {
          display: 'none'
        }
      }}
      w="60px"
      h="60px"
      alignItems="center"
      justifyContent="center"
      overflow="hidden"
    >
      <Text
        ref={textRef}
        className="texto"
        fontSize="lg"
        fontWeight="medium"
        opacity={0}
        whiteSpace="nowrap"
        transition="opacity 0.3s ease"
        position="absolute"
        left="20px"
      >
        {text} +
      </Text>
      <AddIcon className="icono" />
    </Flex>
  );
};

export default FloatingAddButton;